exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".verify-token[data-v-39e75f60]{position:relative}.verify-token p[data-v-39e75f60]{position:absolute;left:0;right:0;bottom:50px}p.text-center.loaded[data-v-39e75f60]{bottom:0;position:relative;margin:80px 0}", ""]);

// exports
